module.exports = __webpack_public_path__ + "static/media/j_of_hearts2.3ec3afca.png";